import React from 'react';
import Icon, { IconProps } from '../Icon';

const IconZoomV2: React.FC<IconProps> = ({ ...props }) => {
  const fill = props.fill;

  return (
    <Icon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.1219 7.2C20.9672 7.2 20.8172 7.24219 20.6859 7.32656L16.6313 9.88594C16.5141 9.96094 16.4438 10.0875 16.4438 10.2234V13.7859C16.4438 13.9219 16.5141 14.0484 16.6313 14.1234L20.6859 16.6828C20.8172 16.7625 20.9672 16.8094 21.1219 16.8094H22.0969C22.3219 16.8094 22.5 16.6313 22.5 16.4109V7.59844C22.5 7.37813 22.3172 7.2 22.0969 7.2H21.1219ZM12.8203 18H3.91406C2.5875 18 1.5 16.9125 1.5 15.5906V8.40937C1.5 7.08281 2.5875 6 3.90937 6H12.8156C14.1422 6 15.225 7.0875 15.225 8.40937V15.5859C15.2297 16.9125 14.1469 18 12.8203 18Z"
        fill={fill || 'white'}
      />
    </Icon>
  );
};

export default IconZoomV2;
